import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { type Types } from '@fiverr-private/theme';
import MenuDivider from '../DropdownMenu/MenuDivider';
import useDropdownContext from '../Dropdown/useDropdownContext';
import { divider } from './styles.ve.css';

const DropdownSectionColumn = ({
  children,
  withDivider,
}: {
  children: Types.FlexLayoutProps['children'];
  withDivider?: boolean;
}) => {
  const { isMobileView } = useDropdownContext();

  return (
    <Stack
      width="100%"
      direction={isMobileView ? 'column' : 'row'}
      paddingX="2"
      className={withDivider && !isMobileView ? divider : undefined}
      position="relative"
    >
      {children}
      {withDivider && isMobileView && <MenuDivider />}
    </Stack>
  );
};

DropdownSectionColumn.displayName = 'DropdownSectionColumn';
export default DropdownSectionColumn;
